// @ts-strict-ignore
import React, { useContext } from 'react';
import RHSMultiSelect from './RHSMultiSelect';
import RHSDatePicker from './RHSDatePicker';
import RHSIsolatedEditorField from './RHSIsolatedEditorField';
import RHSRangeInput from './RHSRangeInput';
import { getEditorOriginType, getRHSComponentType } from './helpers';
import { rhsComponentType } from './types';
import RHSCreatable from './RHSCreatable';
import { isMultiSelectRHS } from '../helpers';
import { ThresholdContext } from '../context';
import { StyledEditableControlContainer } from '../../styles';
import { MLAType } from 'flow/service/mla';
import MLASuperset from '../MLASuperset';
import { UserContext } from '~/dashboard/context';


const RHSWrapper = () => {
  const {
    isDynamic,
    lhsDataType,
    populatedThreshold,
  } = useContext(ThresholdContext);

  const {
    operator,
    left,
    right: { attributeValue },
  } = populatedThreshold;

  const { attribute: leftAttribute, action: leftAction } = left;
  const actionType = leftAction.type;

  const { featureFlags } = useContext(UserContext);
  const supportsBestEffortParsing = featureFlags.allowBestEffortRuleEvaluations;

  const componentType = getRHSComponentType({
    lhsDataType,
    operator,
    leftAttribute,
    actionType,
    isDynamic,
  });

  const shouldUseDefaultString = (
    supportsBestEffortParsing
    && lhsDataType === 'string'
    && ['e', 'ne'].includes(operator)
  );

  const renderRHSComponent = () => {
    switch (componentType) {
      case (rhsComponentType.creatable): {
        const values = attributeValue != null ? String(attributeValue).split(',') : [''];
        return (
          <RHSCreatable
            shouldUseDefaultString={shouldUseDefaultString}
            values={values}
          />
        );
      }
      case (rhsComponentType.datePicker): {
        return (
          <RHSDatePicker shouldUseDefaultString={shouldUseDefaultString} />
        );
      }
      case (rhsComponentType.isolatedEditor): {
        return (
          <RHSIsolatedEditorField
            originType={getEditorOriginType({ lhsDataType, operator })}
          />
        );
      }
      case (rhsComponentType.range): {
        const values = attributeValue != null ? String(attributeValue).split(',') : [''];
        return (
          <RHSRangeInput
            shouldUseDefaultString={shouldUseDefaultString}
            values={values}
          />
        );
      }
      default: {
        return (
          <RHSMultiSelect
            /* Note: we use the multiselect component for single select too */
            isMultiSelect={isMultiSelectRHS({ lhsDataType, leftAttribute })}
            shouldUseDefaultString={shouldUseDefaultString}
            supportsBestEffortParsing={supportsBestEffortParsing}
          />
        );
      }
    }
  };

  return (
    <StyledEditableControlContainer>
      {renderRHSComponent()}
      <MLASuperset type={MLAType.THRESHOLD_RIGHT} />
    </StyledEditableControlContainer>
  );
};

export default RHSWrapper;
